/*eslint new-cap:0 */
import ko from 'knockout';
import longAdTitle from '@bingads-webui-campaign-legacy/crud-ad/longAdTitle';

export default class ViewModel {
  constructor(previewModel = {}) {
    this.previewTitleAndText = ko.computed(() => {
      return longAdTitle.generate(previewModel.Text(), previewModel.DisplayUrl(), previewModel.Title());
    });

    //mainline title
    this.Title = ko.computed(() => {
      return this.previewTitleAndText().title;
    });

    //mainline text
    this.Text = ko.computed(() => {
      return this.previewTitleAndText().description;
    });

    this.DisplayUrl = previewModel.DisplayUrl;
    this.DestinationUrl = previewModel.DestinationUrl;

    this.adViewModel = previewModel.adViewModel;
  }
}
